module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event/event_photo-bbf2b91dbb44ac9adbf482f4efb54cf1.jpg";